import { useMutation, useQueryClient } from "@tanstack/react-query";
import { generateReport } from "PFCore/services/export_booking";
import { GenerateReportPayload } from "PFCore/services/export_booking/export_booking.types";
import { MutationOptions } from "PFTypes/request_options";

import { queryKeys } from "../query_keys";
import { generateReportKeys } from "./query_keys";

export const useGenerateReport = ({ onSuccess, onError }: MutationOptions<GenerateReportPayload>) => {
  const queryClient = useQueryClient();
  return useMutation(async (payload: GenerateReportPayload) => generateReport(payload), {
    mutationKey: generateReportKeys.generate(),
    onSuccess: (...args) => {
      queryClient.invalidateQueries(generateReportKeys.all());
      queryClient.invalidateQueries(queryKeys.reports);
      onSuccess?.(...args);
    },
    onError
  });
};
